export default __webpack_public_path__ + "static/media/1.f3f1e645.jpg";